import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import cleanup from "../utils/barcode_cleanup"

export const Barcode = CreateRenderFunction({
  props: {
    name: "",
    value: "",
    placeholder: "",
  },
  data: {
    barcode: "",
  },
  init() {
    this.barcode = cleanup(this.value)
  },
  methods: {
    cleanup() {
      this.barcode = cleanup(this.barcode)
    },
  },
  watch: {
    barcode() {
      this.cleanup()
    },
  },
  render() {
    return (
      <input
        value={this.barcode}
        onInput={(e: Event) => {
          this.barcode = (e.target as HTMLInputElement).value
        }}
        autocomplete="off"
        class="form-control"
        name={this.name}
        placeholder={this.placeholder}
        type="text"
      />
    )
  },
})
